var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTuerca = function SvgTuerca(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.8 29.46"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8 6.49h-8.79L11.11 0h6.59zM10.01 22.97h8.79l-1.1 6.49h-6.59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4 3.64a11.09 11.09 0 1 0 11.09 11.09A11.09 11.09 0 0 0 14.4 3.64m0 17.08a6 6 0 1 1 6-6 6 6 0 0 1-6 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8 6.49h-8.79L11.11 0h6.59zM10.01 22.97h8.79l-1.1 6.49h-6.59zM9.46 6.8l-4.39 7.61L0 10.22l3.29-5.71zM19.34 22.65l4.39-7.61 5.07 4.2-3.29 5.71zM5.07 15.04l4.39 7.61-6.17 2.3L0 19.24zM23.73 14.41 19.34 6.8l6.17-2.29 3.29 5.71z"
  })))));
};
export default SvgTuerca;